// POD 审核失败分类配置
export const podInvalidKeyword = {
  // 筛选项
  categoryNameOrKeyword: {
    zh: '分类名称 / 关键词',
    en: 'Category / Keyword',
    pu: 'Categoria / Palavra-chave'
  },
  searchPlaceholder: {
    zh: '请输入中文、葡语名称或关键词',
    en: 'Enter the Chinese name, Portuguese name or keyword',
    pu: 'Digite o nome em chinês, português ou palavra-chave'
  },
  invalidType: {
    zh: '不合格类型',
    en: 'Invalid Type',
    pu: 'Tipo inválido'
  },
  all: {
    zh: '全部',
    en: 'All',
    pu: 'Todos'
  },
  status: {
    zh: '状态',
    en: 'Status',
    pu: 'Status'
  },
  enabled: {
    zh: '启用',
    en: 'Enabled',
    pu: 'Ativo'
  },
  disabled: {
    zh: '停用',
    en: 'Disabled',
    pu: 'Inativo'
  },
  search: {
    zh: '搜索',
    en: 'Search',
    pu: 'Pesquisar'
  },
  reset: {
    zh: '重置',
    en: 'Reset',
    pu: 'Redefinir'
  },

  // 列表
  addCategory: {
    zh: '新增分类',
    en: 'Add Category',
    pu: 'Nova categoria'
  },
  editCategory: {
    zh: '编辑分类',
    en: 'Edit Category',
    pu: 'Editar categoria'
  },
  total: {
    zh: '共 {total} 条',
    en: '{total} in total',
    pu: 'Total de {total}'
  },
  serialNumber: {
    zh: '序号',
    en: 'No.',
    pu: 'Nº'
  },
  typePhoto: {
    zh: '图片不合格',
    en: 'Invalid Photo',
    pu: 'Foto inválida'
  },
  typeSignature: {
    zh: '签名不合格',
    en: 'Invalid Signature',
    pu: 'Assinatura inválida'
  },
  nameZh: {
    zh: '分类中文名称',
    en: 'Category Name (Chinese)',
    pu: 'Nome da categoria (chinês)'
  },
  namePu: {
    zh: '分类葡语名称',
    en: 'Category Name (Portuguese)',
    pu: 'Nome da categoria (português)'
  },
  keywords: {
    zh: '包含关键词',
    en: 'Keywords',
    pu: 'Palavras-chave'
  },
  operation: {
    zh: '操作',
    en: 'Operation',
    pu: 'Operação'
  },
  edit: {
    zh: '编辑',
    en: 'Edit',
    pu: 'Editar'
  },
  delete: {
    zh: '删除',
    en: 'Delete',
    pu: 'Excluir'
  },
  deleteConfirm: {
    zh: '确定删除该分类吗？',
    en: 'Are you sure to delete this category?',
    pu: 'Deseja realmente excluir esta categoria?'
  },
  enabledSuccess: {
    zh: '已启用',
    en: 'Enabled',
    pu: 'Ativado'
  },
  disabledSuccess: {
    zh: '已停用',
    en: 'Disabled',
    pu: 'Desativado'
  },
  deleteSuccess: {
    zh: '删除成功',
    en: 'Deleted successfully',
    pu: 'Excluído com sucesso'
  },

  // 弹窗 / 表单
  pleaseSelect: {
    zh: '请选择',
    en: 'Please select',
    pu: 'Selecione'
  },
  nameZhPlaceholder: {
    zh: '请输入中文名称',
    en: 'Enter the Chinese name',
    pu: 'Digite o nome em chinês'
  },
  namePuPlaceholder: {
    zh: '请输入葡语名称',
    en: 'Enter the Portuguese name',
    pu: 'Digite o nome em português'
  },
  keywordPlaceholder: {
    zh: '输入关键词后按回车添加',
    en: 'Type a keyword and press Enter',
    pu: 'Digite a palavra-chave e pressione Enter'
  },
  keywordTip: {
    zh: '支持添加多个关键词，按 Enter 添加，点击 × 删除。匹配时命中任意关键词即可。',
    en: 'Multiple keywords are supported. Press Enter to add and click × to remove. A match is made when any keyword is hit.',
    pu: 'É possível adicionar várias palavras-chave. Pressione Enter para adicionar e clique em × para remover. A correspondência é feita quando qualquer palavra-chave é acertada.'
  },
  cancel: {
    zh: '取消',
    en: 'Cancel',
    pu: 'Cancelar'
  },
  confirm: {
    zh: '确定',
    en: 'Confirm',
    pu: 'Confirmar'
  },
  addSuccess: {
    zh: '新增成功',
    en: 'Added successfully',
    pu: 'Adicionado com sucesso'
  },
  editSuccess: {
    zh: '修改成功',
    en: 'Updated successfully',
    pu: 'Atualizado com sucesso'
  },

  // 表单校验
  typeRequired: {
    zh: '请选择不合格类型',
    en: 'Please select the invalid type',
    pu: 'Selecione o tipo inválido'
  },
  nameZhRequired: {
    zh: '请输入分类中文名称',
    en: 'Please enter the Chinese category name',
    pu: 'Digite o nome da categoria em chinês'
  },
  namePuRequired: {
    zh: '请输入分类葡语名称',
    en: 'Please enter the Portuguese category name',
    pu: 'Digite o nome da categoria em português'
  },
  keywordRequired: {
    zh: '请至少添加一个关键词',
    en: 'Please add at least one keyword',
    pu: 'Adicione pelo menos uma palavra-chave'
  }
};
